export const getFilterKeys = (key, filter) => {
  const keys = [];
  filter.map(({ children }) => children.map(item => item[key] && keys.push(item.name)));

  return keys;
};
